import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'
import { defaultUserImg, FilterIcon } from '../../helper/imagepath'
import { itemRender } from '../../helper/paginationfunction'
import { Table } from 'antd'
import CustomModal from '../../component/customModal'
import DeletePopup from '../../component/deletePopup'
import AddEditGhostClient from './addEditGhostClient'
import FeatherIcon from 'feather-icons-react'
import {
  getTimeStamp,
  getUserRole,
  handleImageError,
  hasAccess,
  maskPhoneNumber,
  toLowerCaseString,
  appendImageURL,
  getDayStartAndEndTimestamps,
  formatCustomTrim
} from '../../helper/function'
import ClientsFilter from './clientsFilter'
import { deleteClient, getAllClient } from '../../redux/slices/clientSlice'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { errorToast, successToast } from '../../util/Toast/toast'
import { getAllRegion } from '../../redux/slices/regionSlice'

const Clients = () => {
  const { changeLoader } = useContext(SpinnerContext)
  const { allClient } = useSelector(({ client }) => client)
  const [showModal, setShowModal] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [clientID, setClientID] = useState(null)
  const [editData, setEditData] = useState([])
  const [pagesize, setPagesize] = useState(10)
  const [page, setPage] = useState(1)
  const [totalCount, setTotalCount] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [filterData, setFilterData] = useState({})
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const toggleModal = () => setShowModal(!showModal)

  useEffect(() => {
    changeLoader(true)
    dispatch(getAllRegion()).finally(() => changeLoader(false))
  }, [])

  const onDelete = () => {
    if (clientID) {
      changeLoader(true)
      dispatch(deleteClient(clientID)).then(({ payload, error }) => {
        changeLoader(false)
        if (payload?.status === 200) {
          setIsRefresh(true)
          openDeleteModal()
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
        }
      })
    }
  }

  const handlePagination = async (page, pageSize) => {
    setPage(page)
    setPagesize(pageSize)
    setIsRefresh(true)
  }

  useEffect(() => {
    if (!isRefresh) {
      return
    }

    const { endOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(filterData?.created_end))
    const params = {
      page,
      limit: pagesize,
      region: filterData?.region,
      city: filterData?.city,
      is_ghost: filterData?.is_ghost,
      property_count: filterData?.property_count,
      created_start: filterData?.created_start && getTimeStamp(filterData.created_start),
      created_end: filterData?.created_end && endOfDayTimestamp,
      sort_column: 'created_at',
      sort_order: 'DESC'
    }

    if (filterData?.name) params['name'] = formatCustomTrim(filterData.name)
    changeLoader(true)
    dispatch(getAllClient(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
        setIsRefresh(false)
      })
  }, [page, pagesize, isRefresh, filterData])

  const columns = [
    {
      title: 'No',
      render: (value, item, index) => (page - 1) * pagesize + (index + 1)
    },
    {
      title: 'Client',
      dataIndex: 'client',
      render: (text, record) => {
        return (
          <div className="table-avatar d-flex align-items-center">
            <div className="avatar avatar-sm me-2">
              <img
                className="avatar-img rounded-circle"
                onError={handleImageError}
                src={record?.profile ? appendImageURL(record?.profile) : defaultUserImg}
                alt="User Image"
              />
            </div>
            <div>
              <p>{`${record.first_name || ''} ${record.last_name || ''}`}</p>
              {/* Ensure email is rendered in lowercase */}
              <span className="lowercase">{toLowerCaseString(record.email)}</span>
            </div>
          </div>
        )
      }
    },
    {
      title: 'Phone',
      dataIndex: 'contact_no',
      render: (text) => (text ? maskPhoneNumber(text) : '-')
    },
    {
      title: 'Total Properties',
      dataIndex: 'property_count',
      render: (text) => text
    },
    {
      title: 'Total Cleanings',
      dataIndex: 'total_cleanings',
      render: (text) => text
    },
    {
      title: 'Total Strikes',
      dataIndex: 'strikes',
      render: (text) => text
    },
    // {
    //   title: 'Rating',
    //   dataIndex: 'rating_score',
    //   render: (text) => (
    //     <span className="badge badge-pill bg-warning-light" style={{ color: '#878AB3' }}>
    //       {text ? text : '0'}
    //     </span>
    //   )
    // },
    {
      title: 'Action',
      render: (record) => (
        <div className="d-flex align-items-center">
          {
            <Link
              className="btn-action-icon me-2 edit_icon_div"
              onClick={(event) => {
                event.stopPropagation()
                setClientID(record?.client_id)

                const filtered = allClient?.clients?.find((user) => user?.client_id === record?.client_id)
                setEditData(filtered)
                toggleModal()
              }}
            >
              <i className="fe fe-edit d-flex align-items-center justify-content-center" style={{ color: 'primary' }}>
                <FeatherIcon icon="edit" className="icon-primary" />
              </i>
            </Link>
          }
          {
            <Link
              className="btn-action-icon delete_icon_div"
              onClick={(event) => {
                event.stopPropagation()
                setClientID(record.client_id)
                openDeleteModal()
              }}
            >
              <i className="fe fe-trash-2 d-flex align-items-center justify-content-center">
                <FeatherIcon icon="trash-2" color="red" />
              </i>
            </Link>
          }
        </div>
      )
    }
  ].filter(Boolean)

  const visibleColumns = hasAccess('clientsAction', getUserRole()) ? columns : columns.filter((column) => column.title !== 'Action')

  return (
    <>
      <div className="page-wrapper customers">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="content-page-header">
              <h5>Clients</h5>
              <div className="list-btn">
                <ul className="filter-list">
                  <li>
                    <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                      <span className="me-2">
                        <img src={FilterIcon} alt="filter" />
                      </span>
                      Filter{' '}
                    </Link>
                  </li>
                  <li>
                    {hasAccess('clientsAction', getUserRole()) && (
                      <Button
                        className="btn btn-primary"
                        onClick={() => {
                          setEditData(null)

                          toggleModal()
                          setClientID(null)
                        }}
                      >
                        <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                        Add Ghost Client
                      </Button>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="table-card-div">
                <div className="card-table">
                  <div className="card-body purchase">
                    <div className="table-responsive table-hover">
                      <Table
                        rowKey={(record) => record?.id}
                        onRow={(record) => {
                          return {
                            onClick: (event) => {
                              event.stopPropagation()
                              navigate(`/clients/clientInfo/${record?.client_id}`)
                            },
                            className: 'clickable-row'
                          }
                        }}
                        pagination={{
                          total: allClient?.totalRecords || totalCount,
                          defaultPageSize: allClient?.limit || 10,
                          defaultCurrent: allClient?.currentPage || 1,
                          current: page,
                          pageSize: pagesize,
                          showSizeChanger: true,
                          pageSizeOptions: [10, 25, 50, 100],
                          onChange: (page, pageSize) => handlePagination(page, pageSize),
                          itemRender: itemRender
                        }}
                        columns={visibleColumns}
                        dataSource={allClient?.clients || []}
                        scroll={allClient?.clients?.length > 0 ? { x: true } : false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ClientsFilter
        setShowFilter={setShowFilter}
        showFilter={showFilter}
        pagesize={pagesize}
        page={page}
        setFilterData={setFilterData}
        setTotalCount={setTotalCount}
        setPagesize={setPagesize}
        setPage={setPage}
        handlePagination={handlePagination}
        setIsRefresh={setIsRefresh}
      />
      <CustomModal isOpen={showModal} toggle={toggleModal} title={clientID ? `Edit ${editData?.is_ghost ? 'Ghost' : ''} Client` : `Add Ghost Client`}>
        <AddEditGhostClient clientID={clientID} editData={editData} toggle={toggleModal} setIsRefresh={setIsRefresh} />
      </CustomModal>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger common-field-btn w-100"
              onClick={(e) => {
                e.preventDefault()
                onDelete()
              }}
            >
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </>
  )
}

export default Clients
